import React, { Component } from "react";
import { connect } from "react-redux";
import * as meetingActions from "../../actions/meeting.action";
import * as positionActions from "../../actions/other_info/position.action";
import * as departmentActions from "../../actions/other_info/department.action";
import {
  Row,
  Col,
  FormInput,
  FormSelect,
  Badge
} from "shards-react";
import { Upload, message, Spin, Modal, Button, Drawer, Empty, Descriptions, Tooltip, Radio } from 'antd';
import axios from 'axios'
import { Formik } from "formik";
import { apiUrl } from "../../config/index";
import Swal from "sweetalert2";
import { httpClient } from "../../utils/HttpClient";
import {
  LoadingOutlined,
  EditOutlined,
  DeleteOutlined,
  UserOutlined,
  CopyOutlined
} from '@ant-design/icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Moment from "react-moment";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const FontStyle = ReactQuill.Quill.import('attributors/style/font');
const AlignStyle = ReactQuill.Quill.import('attributors/style/align');

ReactQuill.Quill.register(AlignStyle, true)
ReactQuill.Quill.register(FontStyle, true)

const filesize = require("filesize");

class MeetingEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inviteModalVisible: false,
      addModalVisible: false,
      drawerPreviewVisible: false,
      attendeeLoading: false,
      attendeesFetching: false,
      emailSending: false,
      uploading: false,
      deleting: false,
      positions: [],
      departments: [],
      attendees: [],
      attachments: [],
      singleAttachment: '',
      selectedAttendee: '',
      attendeesCount: {
        all: 0,
        accepted: 0,
        maybe: 0,
        declined: 0,
        waiting: 0
      },
      event: {
        subject: "",
        body: "",
        attendees: []
      },
      attendee: {
        id: '',
        position: '1',
        department: '',
        name: "",
        email: "",
        emailBody: "",
        type: "add",
        attachment: ''
      },
    }

    this.handleAttendeeChange = this.handleAttendeeChange.bind(this);
    this.onInviteConditionChange = this.onInviteConditionChange.bind(this);

    this.quillRef = null
    this.token = localStorage.getItem("token");
  }

  async componentDidMount() {
    await this.getEvent()
    await this.getAttendees()
    await this.props.getAllPositions(this.state.currentPage);
    await this.props.getAllDepartments(this.state.currentPage);
    
    this.setState({
      positions: this.props.positionsReducer.positions,
      departments: this.props.departmentReducer.departments
    })
  }  

  async getEvent() {
    if(this.props.meetingReducer.result.eventId) {
      await this.props.getMeetingEvent(this.props.meetingReducer.result.id, this.props.meetingReducer.result.eventId);
      
      if (this.props.meetingReducer.event) {
        const event = this.props.meetingReducer.event

        const allAttendees = event.attendees.length
        const acceptedCount = event.attendees.filter(item => { return item.status.response === 'accepted' }).length
        const declinedCount = event.attendees.filter(item => { return item.status.response === 'declined' }).length
        const maybeCount = event.attendees.filter(item => { return item.status.response === 'tentativelyAccepted' }).length
        const waitingCount = event.attendees.filter(item => { return item.status.response === 'none' }).length

        const attendeesCount = {
          all: allAttendees,
          accepted: acceptedCount,
          declined: declinedCount,
          maybe: maybeCount,
          waiting: waitingCount
        }

        const eventBody = event.body.content.substring(event.body.content.indexOf("<body>") + 6, event.body.content.indexOf("</body"));

        const eventObj = {
          subject: event.subject,
          body: eventBody.replace(/\t/g, '\u00a0\u00a0\u00a0\u00a0'),
          attendees: event.attendees,
          sendInviteCondition: 1
        };

        this.setState({
          event: eventObj,
          attachments: event.attachments,
          attendeesCount
        });
      } 
    }
  }

  async getAttendees() {
    await this.props.getMeetingAttendees(this.props.meetingReducer.result.id)

    for(const attendee of this.props.meetingReducer.attendees)  {
      attendee.responseStatus = 'new'
      attendee.emailBody = (attendee.emailBody && attendee.emailBody !== '<p><br></p>') ? attendee.emailBody : this.state.event.body.replace(/\t/g, '\u00a0\u00a0\u00a0\u00a0')

      for(const eventAttendee of this.state.event.attendees)  {
        if(eventAttendee.emailAddress.address === attendee.email) {
          attendee.responseStatus = eventAttendee.status.response
        }
      }
    }

    await this.setState({
      attendees: this.props.meetingReducer.attendees,
      attendeesFetching: false
    })
  }

  handleEventChange(value, key) {
    const event = this.state.event;
    event[key] = value;
    this.setState({ event });
  }

  async handleAttendeeChange(value, key) {
    const attendee = this.state.attendee;
    attendee[key] = value;

    await this.setState({ attendee });
  }

  async addAttendee() {
    this.setState({attendeeLoading: true})

    const attendeeParams = {
      meetingId: this.props.meetingReducer.result.id,
      position: this.state.attendee.position,
      department: this.state.attendee.department,
      name: this.state.attendee.name,
      email: this.state.attendee.email,
    }

    try {
      const response = await httpClient.post(
        `/api/meetings/${this.props.meetingReducer.result.id}/attendee`,
        attendeeParams,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        }
      );

      const attendees = this.state.attendees

      attendees.unshift({
        ...response.data, 
        responseStatus: 'new',
        emailBody: this.state.event.body.replace(/\t/g, '\u00a0\u00a0\u00a0\u00a0'),
        attachments: []
      })

      message.success('เพิ่มผู้เข้าประชุมเรียบร้อยแล้ว');
      this.initNewAttendeeData()
      
    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในการเพิ่มผู้เข้าประชุม กรุณาลองใหม่อีกครั้ง');
    }

    this.setState({
      attendeeLoading: false,
      addModalVisible: false
    })
  }

  async getAttendeeDetail(item) {
    this.setState({
      addModalVisible: true,
      attendeeLoading: true
    })
    
    const attendee = {
      id: item.id,
      position: item.position,
      department: item.department,
      name: item.name,
      email: item.email,
      emailBody: (item.emailBody === '' || !item.emailBody) ? this.state.event.body : item.emailBody,
      messageId: item.messageId,
      attachments: item.attachments
    }
    this.setState({
      attendeeLoading: false,
      attendee
    })
  }

  async updateAttendee() {
    this.setState({attendeeLoading: true})

    const attendeeParams = {
      id: this.state.attendee.id,
      position: this.state.attendee.position,
      department: this.state.attendee.department,
      name: this.state.attendee.name,
      email: this.state.attendee.email,
      emailBody: this.state.attendee.emailBody,
    }

    try {
      const response = await httpClient.patch(
        `/api/meetings/${this.props.meetingReducer.result.id}/attendee/${this.state.attendee.messageId}`,
        attendeeParams,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        }
      );

      let attendees = []

      for(const item of this.state.attendees) {
        if(item.id === this.state.attendee.id)  {
          if(item.email !== this.state.attendee.email)  {
            const attendeeList = this.props.meetingReducer.event.attendees.filter(oldAttendee => {
              return oldAttendee.emailAddress.address !== item.email
            })

            const response = await httpClient.post(
              `/api/meetings/${this.props.meetingReducer.result.id}/event/${this.props.meetingReducer.result.eventId}/send`,
              attendeeList,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${this.token}`,
                },
              }
            )

            item.responseStatus = "new"
          }

          item.position = this.state.attendee.position
          item.name = this.state.attendee.name
          item.email = this.state.attendee.email
          item.emailBody = this.state.attendee.emailBody
        }

        attendees.push(item)
      }
        
      await this.setState({attendees})
      message.success('แก้ไขข้อมูลผู้เข้าประชุมเรียบร้อยแล้ว');
      this.initNewAttendeeData()
      
    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในการแก้ไขข้อมูลผู้เข้าประชุม กรุณาลองใหม่อีกครั้ง');
    }

    this.setState({
      attendeeLoading: false,
      addModalVisible: false
    })
  }

  openAttendeeModal()  {
    this.initNewAttendeeData()
    this.setState({addModalVisible: true})
  }

  initNewAttendeeData() {
    let attendee = {
      id: '',
      position: '1',
      department: '1',
      name: "",
      email: "",
      emailBody: "",
      type:"add",
      attachment: ''
    }

    attendee.emailBody = JSON.parse(JSON.stringify(this.state.event.body)).replace(/\t/g, '\u00a0\u00a0\u00a0\u00a0')

    this.setState({ 
      attendee
    })
  }

  deleteConfirmation(attendee) {
    let _this = this

    Modal.confirm({
      title: <div>ยืนยันการลบ <span className="font-weight-bold">{attendee.name}</span> ออกจากรายชื่อผู้เข้าประชุม</div>,
      okText: 'ลบ',
      cancelText: 'ยกเลิก',
      maskClosable: true,
      onOk() {  
        _this.deleteAttendee(attendee.id)
      }
    });
  }

  async deleteAttendee(id)  {
    this.setState({attendeesFetching: true})
    try {
      const response = await httpClient.delete(
        `/api/meetings/${this.props.meetingReducer.result.id}/event/${this.props.meetingReducer.result.eventId}/attendee/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        }
      )

      this.getEvent()

      const attendees = this.state.attendees.filter(item => {
        return item.id !== id
      })

      this.setState({attendees})
      message.success('ลบข้อมูลผู้เข้าประชุมเรียบร้อยแล้ว');

    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในการลบผู้เข้าประชุม กรุณาลองใหม่อีกครั้ง');
    }

    this.setState({attendeesFetching: false})
  }

  deleteAttachmentConfirmation() {
    let _this = this

    Modal.confirm({
      title: <div>ยืนยันการลบเอกสาร <span className="font-weight-bold">{this.state.singleAttachment.name}</span></div>,
      okText: 'ลบ',
      cancelText: 'ยกเลิก',
      maskClosable: true,
      onOk() {  
        _this.deleteAttachment()
      }
    });
  }

  deleteAttachment()  {
    const attendees = this.state.attendees.map(item => {
      if(item.id === this.state.attendee.id)  {
        item.attachment = ''
      }

      return item
    })

    this.setState({
      attendees
    })
  }

  renderRespondBadge(status) {
    if (status === "accepted") {
      return <Badge theme="success">เข้าร่วมการประชุม</Badge>;
    } else if (status === "none" || status === "notResponded") {
      return <Badge theme="secondary">ยังไม่ตอบรับ</Badge>;
    } else if (status === "tentativelyAccepted") {
      return <Badge theme="info">ยังไม่ตัดสินใจ</Badge>;
    } else if (status === "declined") {
      return <Badge theme="danger">ไม่เข้าร่วม</Badge>;
    } else {
      return <Badge theme="info">ยังไม่ได้ส่งคำเชิญ</Badge>;
    }
  }

  renderDocumentIcon(name)  {
    const fileType = name.split('.').pop()
    let fileIcon

    if(fileType === 'jpg' || fileType === 'png')  {
      fileIcon = require("assets/img/image.svg")
    } else if(fileType === 'doc' || fileType === 'docx')  {
      fileIcon = require("assets/img/word.svg")
    } else if(fileType === 'ppt' || fileType === 'pptx')  {
      fileIcon = require("assets/img/ppt.svg")
    } else if(fileType === 'xls' || fileType === 'xlsx' || fileType === 'csv')  {
      fileIcon = require("assets/img/excel.svg")
    } else if(fileType === 'pdf')  {
      fileIcon = require("assets/img/pdf.svg")
    } else  {
      fileIcon = require("assets/img/document.svg")
    }

    return (
      <img
        className="mr-2"
        width="25"
        src={fileIcon}
        alt="Document Icon"
      />
    )
  }

  removeAttachment(index)  {
    const attachments = this.state.attachments
    attachments.splice(index, 1);
    this.setState({attachments})
  }

  async handleUpload(file)  {
    const newFile = {
      name: file.name,
      size: file.size,
      id: file.uid
    }

    let attachments = this.state.attachments
    attachments.push(newFile)
    this.setState({attachments})
    
    const formData = new FormData();
    formData.append('file', file);

    try {
      const uploadResponse = await axios.request({
        method: "post", 
        url: `${apiUrl}/api/meetings/${this.props.meetingReducer.result.id}/event/${this.props.meetingReducer.event.id}/attachment`,
        data: formData, 
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      })

      //Upload final document to google storage
      const storageResponse = await await axios.request({
        method: "post", 
        url: `${apiUrl}/api/meetings/${this.props.meetingReducer.result.id}/event/${this.props.meetingReducer.event.id}/attachment/${uploadResponse.data.id}/upload`,
        data: formData, 
        headers: {
          Authorization: `Bearer ${this.token}`,
        }
      })
      
      for(const item of attachments)  {
        if(item.id === newFile.id)  {
          item.uploading = false
        }
      }

      this.setState({attachments})

      message.success('อัพโหลดเอกสารแนบเรียบร้อยแล้ว');
    } catch(err)  {
      message.error('อัพโหลดเอกสารแนบไม่สำเร็จ');
    }

    this.setState({uploading : false})
  }

  onInviteConditionChange(e) {
    let event = this.state.event
    event.sendInviteCondition = e.target.value
    this.setState({event})
  }

  async updateEvent() {
    const eventLocation = this.props.locationsReducer.locations.filter((item) => {
      return item.id == this.props.meetingReducer.result.location
    })[0].name;

    const eventBuilding = this.props.buildingsReducer.buildings.filter((item) => {
      return item.id == this.props.meetingReducer.result.building
    })[0].name;

    const eventRoom = this.props.roomsReducer.rooms.filter((item) => {
      return item.id == this.props.meetingReducer.result.room
    })[0].name;

    const eventFullLocation = `${eventLocation} ${eventBuilding} ${eventRoom}`;

    const eventParams = {
      subject: this.state.event.subject,
      body: {
        contentType: "HTML",
        content: this.state.event.body.replace(/\t/g, '\u00a0\u00a0\u00a0\u00a0'),
      },
      start: {
        dateTime: this.props.meetingReducer.result.meetingStart,
        timeZone: "Asia/Bangkok",
      },
      end: {
        dateTime: this.props.meetingReducer.result.meetingEnd,
        timeZone: "Asia/Bangkok",
      },
      location: {
        displayName: eventFullLocation,
      }
    }

    try {
      const response = await httpClient.patch(
        `/api/meetings/${this.props.meetingReducer.result.id}/event/${this.props.meetingReducer.result.eventId}`,
        {
          event: eventParams,
          attachment: this.state.event.attachment,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        }
      )
      
      message.success('บันทึกข้อมูลเรียบร้อบแล้ว');
      this.setState({inviteModalVisible: false})
    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในกาบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง');
    }
  }

  async sendEmail() {
    this.setState({emailSending: true})
    const currentEventAttendees = this.props.meetingReducer.event.attendees
    
    const attendeeList = this.state.attendees.map(attendee => {
      const oldAttendee = currentEventAttendees.filter(item => {
        return item.emailAddress.address === attendee.email
      })[0]

      const responseStatus = oldAttendee ? oldAttendee.status.response : 'none'

      return {
        emailAddress: {
          address: attendee.email.replace(/\s+/g, ''),
          name: attendee.name
        },
        status: {
          response: responseStatus
        }
      }
    })

    try {
      const response = await httpClient.post(
        `/api/meetings/${this.props.meetingReducer.result.id}/event/${this.props.meetingReducer.result.eventId}/send`,
        attendeeList,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        }
      )      
    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในการส่งอีเมลเชิญประชุม กรุณาลองใหม่อีกครั้ง');
    }

    for(const attendee of this.state.attendees) {
      let isSend = false
      
      if(this.state.event.sendInviteCondition === 1)  {
        isSend = true
      } else if(this.state.event.sendInviteCondition === 2 && attendee.responseStatus === 'new') {
        isSend = true
      }

      if(isSend)  {
        const formData = new FormData();
        formData.append('file', attendee.attachment);
        formData.append('email', attendee.email.replace(/\s+/g, ''));
        formData.append('subject', this.state.event.subject);
        formData.append('mailBody', `<p>เรียน ${attendee.name}</p>
          ${attendee.emailBody.replace(/\t/g, '\u00a0\u00a0\u00a0\u00a0')}
        `);

        try {
          const mailResponse = await httpClient.post(
            `/api/meetings/${this.props.meetingReducer.result.id}/mail/send`,
            formData,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.token}`,
              },
            }
          )
        } catch(err){
          message.error(`เกิดข้อผิดพลาดในการส่งอีเมลไปที่ ${attendee.email} กรุณาตรวจสอบอีเมลให้ถูกต้อง`);
        }
      }
    }
    
    message.success('ส่งอีเมลเรียบร้อยแล้ว');
    this.setState({
      inviteModalVisible: false,
      emailSending: false
    })
  }

  async sendSingleEmail() {
    this.setState({emailSending: true})
    
    const formData = new FormData();
    formData.append('file', this.state.singleAttachment);
    formData.append('email', this.state.attendee.email);
    formData.append('subject', this.state.event.subject);
    formData.append('mailBody', `<p>เรียน ${this.state.attendee.name}</p>
      ${this.state.attendee.emailBody.replace(/\t/g, '\u00a0\u00a0\u00a0\u00a0')}
    `);

    try {
      const mailResponse = await httpClient.post(
        `/api/meetings/${this.props.meetingReducer.result.id}/mail/send`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        }
      )

      message.success('ส่งอีเมลเรียบร้อยแล้ว');
      this.setState({addModalVisible: false})

    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในการส่งอีเมล กรุณาลองใหม่อีกครั้ง');
    }

    this.setState({emailSending: false})
  }

  async handleAttachmentUpload(file)  {
    this.setState({uploading : true})
    const formData = new FormData();
    formData.append('file', file);
    formData.append('attendeeId', this.state.attendee.id);

    try {
      const uploadResponse = await axios.request({
        method: "post", 
        url: `${apiUrl}/api/meetings/${this.props.meeting.id}/upload/file/${this.props.meeting.rootFolder}/6`,
        data: formData, 
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      })

      this.state.attendee.attachments.push(uploadResponse.data)

    } catch(e)  {
      message.error('อัพโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง');
    }

    this.setState({uploading : false})
  }

  async deleteDocument(file, index)  {
    this.setState({ deleting: true })

    try   {
      const response = await httpClient.delete(
        `/api/document/${file.documentId}/${this.props.meeting.deletedFolder}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`
          },
        }
      );

      message.success(<span><span className="font-weight-bold">{file.name}</span> ถูกลบเรียบร้อยแล้ว.</span>);

      this.state.attendee.attachments.splice(index, 1)

      this.setState({ deleting: false })
    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในการลบเอกสาร กรุณาลองใหม่อีกครั้ง');
      this.setState({ deleting: false })
    } 
  }

  render()  {
    const { attachments } = this.state

    this.attachmentProps = {
      showUploadList: false,
      multiple: true,
      customRequest: (info) => this.handleUpload(info.file)
    };

    this.singleAttachmentProps = {
      showUploadList: false,
      multiple: false,
      customRequest: (info) => this.handleAttachmentUpload(info.file), 
    };

    const quillModule = {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'align': null}, {'align': 'center'}, {'align': 'right'}],
        ['link']
      ]
    }

    return (
      <React.Fragment>
        <div className="text-right mb-4">
          <Button
            type="primary"
            htmlType="button"
            className="mr-2"
            disabled={this.props.meeting.editable === 'N'}
            onClick={() => this.setState({ inviteModalVisible: true })}
          >
            เชิญประชุม
          </Button>
          <Button
            onClick={() => this.openAttendeeModal()}
            disabled={this.props.meeting.editable === 'N'}
            >เพิ่มผู้เข้าประชุม
          </Button> 
        </div>
        <div className="mb-4 attendee-desc">
          <Descriptions column={5} bordered size="small">
            <Descriptions.Item label="ส่งคำเชิญ">{ this.state.attendeesCount.all }</Descriptions.Item>
            <Descriptions.Item label="ตอบรับ">{ this.state.attendeesCount.accepted }</Descriptions.Item>
            <Descriptions.Item label="อาจจะเข้าร่วม">{ this.state.attendeesCount.maybe }</Descriptions.Item>
            <Descriptions.Item label="ปฏิเสธ">{ this.state.attendeesCount.declined }</Descriptions.Item>
            <Descriptions.Item label="ยังไม่ตอบรับ">{ this.state.attendeesCount.waiting }</Descriptions.Item>
          </Descriptions>
        </div>

        <Spin 
          spinning={this.props.meetingReducer.isAttendeesFetching || this.state.attendeesFetching}
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        > 
          { this.state.attendees.length > 0 ?
            (    
              this.state.attendees.map((item, index) => {
                return (
                  <div className="border p-3 mb-3 rounded d-flex align-items-center" key={index}>
                    <div className="flex-fill">
                      <h6 className="font-weight-bold mb-0 d-flex align-items-end">
                        {item.name} 
                        <small className="font-weight-normal text-muted d-flex align-items-center ml-2">
                          <span className="d-flex align-items-center position-relative" style={{top: 2}}>
                            <UserOutlined className="mr-1" style={{marginTop:-1}} /> {item.positionName}
                          </span>
                        </small>
                      </h6>
                      <div className="text-muted d-flex align-items-center">
                        {item.email}
                        <span style={{ width: 5, height: 5, borderRadius: '50em', background: '#bbb'}} className="mx-2 mt-1" />
                        {item.departmentName}
                      </div>
                    </div>
                    <div className="mx-4">
                      {this.renderRespondBadge(
                        item.responseStatus
                      )}
                    </div>
                    <Tooltip title="แก้ไข">
                      <EditOutlined 
                        className="ml-3 pointer" 
                        style={{fontSize: 20}}
                        onClick={() => this.getAttendeeDetail(item)}
                      />
                    </Tooltip>
                    <Tooltip title="ลบ">
                      <DeleteOutlined 
                        className="ml-3 pointer" 
                        style={{fontSize: 20}}
                        onClick={() => this.deleteConfirmation(item)}
                      />
                    </Tooltip>
                  </div>
                )
              })
            ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="ไม่มีข้อมูลผู้เข้าประชุม" className="mt-5"/>
          }
        </Spin>

        <Modal
          title="เชิญประชุม"
          width={800}
          visible={this.state.inviteModalVisible}
          onCancel={() => this.setState({inviteModalVisible: false})}
          style={{ top: 20 }}
          footer={
            <React.Fragment>
              <Button
                type="primary"
                htmlType="button"
                onClick={(e) => this.updateEvent()}
                className="mr-2"
                disabled={this.state.emailSending}
                style={{
                  width: 100,
                }}
              >
                บันทึก
              </Button>
              <Button
                onClick={() => {
                  const _this = this
                  Modal.confirm({
                    title: <div>ยืนยันการส่งอีเมล</div>,
                    okText: 'ส่งอีเมล',
                    cancelText: 'ยกเลิก',
                    maskClosable: true,
                    onOk() {  
                      _this.sendEmail()
                    }
                  });
                }}
                disabled={this.state.emailSending}
                loading={this.state.emailSending}
                htmlType="button"
                style={{ minWidth: 100 }}
              >
                { this.state.emailSending ? 'กำลังส่งอีเมล' : 'ส่งอีเมล' }
              </Button>
            </React.Fragment>
          }
        >
          <Formik
            initialValues={{}}
            render={({ values, handleChange }) => (
              <React.Fragment>
                <Row form>
                  <Col md="12" className="form-group">
                    <label>หัวข้อการเชิญ</label>
                    <FormInput
                      name="mailTitle"
                      id="mailTitle"
                      onChange={(e) =>
                        this.handleEventChange(e.target.value, "subject")
                      }
                      value={this.state.event.subject}
                    />
                  </Col>
                </Row>
                
                <Row form>
                  <Col md="12" className="form-group">
                    <label>รายละเอียดอีเมล</label>
                    <div className="mail-editor">
                      <ReactQuill 
                        ref={(el) => this.quillRef = el}
                        theme="snow" 
                        value={this.state.event.body} 
                        modules={quillModule}
                        onChange={(value) => this.handleEventChange(value, 'body')}
                      />
                    </div>
                  </Col>
                </Row>

                <Row form>
                  <Col md="12" className="form-group">
                    <label className="mb-0">เอกสารเชิญประชุม</label>
                    <p className="text-muted font-12 mb-0">เลือกเงื่อนไขการส่งเอกสารเชิญประชุมให้แก่ผู้เข้าประชุม</p>
                    <Radio.Group onChange={this.onInviteConditionChange} value={this.state.value} className="mt-3" value={this.state.event.sendInviteCondition}>
                      <Radio value={1}>ผู้เข้าประชุมทุกคน</Radio>
                      <Radio value={2}>เฉพาะคนที่ยังไม่เคยได้รับ</Radio>
                    </Radio.Group>
                  </Col>
                </Row>

                {/* <div className="d-flex align-items-center">
                  <div className="flex-fill">
                    <label className="mb-0">เอกสารแนบ</label>
                    <p className="text-muted font-12 mb-0">เอกสารจะถูกบันทึกอัตโนมัติหลังจากเลือกเอกสารจากเครื่องของคุณ</p>
                  </div>
                    
                  <div>
                    <Upload {...this.attachmentProps}>
                      <Button>เลือกเอกสารแนบ</Button>
                    </Upload>
                  </div>
                </div>  

                { this.state.attachments.length > 0 ?
                  <div className="d-flex flex-wrap mt-2">
                    { 
                      this.state.attachments.map((item, index) => {
                        return (
                          <Spin
                            spinning={item.uploading}
                            key={index}
                            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
                          >
                            <div className="border py-2 px-3 mt-2 d-flex align-items-center mr-3 rounded">
                              { this.renderDocumentIcon(item.name) }
                              <div className="ml-2">
                                <a href={item.webUrl} className="text-dark" style={{marginTop:-2}}>{ item.name }</a>
                                <div className="font-12 text-muted">{ filesize(item.size) }</div>
                              </div>
                              <DeleteOutlined 
                                className="ml-3 pointer" 
                                onClick={() => this.removeAttachment(index)}
                              />
                            </div>
                          </Spin>
                        )
                      })
                    }
                  </div> : <Empty description="ไม่มีเอกสารแนบ" className="mt-2" />
                } */}
              </React.Fragment>
            )}
          />
        </Modal>

        <Modal
          title="ผู้เข้าประชุม"
          width={800}
          visible={this.state.addModalVisible}
          closable={false}
          maskClosable={!this.state.attendeeLoading && !this.state.uploading}
          onCancel={() => this.setState({addModalVisible: false})}
          style={{ top: 20 }}
          footer={
            <div className="text-right">
              <Button 
                type="primary" 
                htmlType="button" 
                className="mr-2"
                loading={this.state.attendeeLoading}
                style={{width: 100}}
                disabled={this.state.uploading}
                onClick={() => this.state.attendee.type === 'add' ? this.addAttendee() : this.updateAttendee()}
              >
                บันทึก
              </Button>
              <Button 
                htmlType="button" 
                disabled={this.state.emailSending}
                loading={this.state.emailSending}
                disabled={this.state.uploading}
                style={{width: 100}}
                onClick={() => {
                  const _this = this
                  Modal.confirm({
                    title: <div>ยืนยันการส่งอีเมลให้ { this.state.attendee.name }</div>,
                    okText: 'ส่งอีเมล',
                    cancelText: 'ยกเลิก',
                    maskClosable: true,
                    onOk() {  
                      _this.sendSingleEmail()
                    }
                  });
                }}
              >
                ส่งอีเมล
              </Button>
            </div>
          }
        >
          <Spin 
            spinning={this.state.attendeeLoading}
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          >
            <Row form>
              <Col md="12" className="form-group">
                <label>ชื่อ</label>
                <FormInput
                  name="attendeeName"
                  id="attendeeName"
                  placeholder="ชื่อผู้เข้าประชุม"
                  onChange={(e) =>
                    this.handleAttendeeChange(e.target.value, "name")
                  }
                  value={this.state.attendee.name}
                />
              </Col>
            </Row>

            <Row form>
              <Col md="12" className="form-group">
                <label>อีเมล</label>
                <FormInput
                  name="attendeeEmail"
                  id="attendeeEmail"
                  placeholder="อีเมลผู้เข้าประชุม"
                  onChange={(e) =>
                    this.handleAttendeeChange(e.target.value, "email")
                  }
                  value={this.state.attendee.email}
                />
              </Col>
            </Row>

            <Row form>
              <Col md="6" className="form-group">
                <label>ตำแหน่ง</label>
                <FormSelect
                  name="attendeePosition"
                  id="attendeePosition"
                  onChange={(e) =>
                    this.handleAttendeeChange(e.target.value, "position")
                  }
                  value={this.state.attendee.position}
                >
                  {this.state.positions.map((item) => {
                    return (
                      <option value={item.id} key={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </FormSelect>
              </Col>
              <Col md="6" className="form-group">
                <label>หน่วยงาน</label>
                <FormSelect
                  name="attendeeDepartment"
                  id="attendeeDepartment"
                  onChange={(e) =>
                    this.handleAttendeeChange(e.target.value, "department")
                  }
                  value={this.state.attendee.department}
                >
                  {this.state.departments.map((item) => {
                    return (
                      <option value={item.id} key={item.id}>
                        {item.name}
                      </option>
                    );
                  })}
                </FormSelect>
              </Col>
            </Row>
            
            { this.state.attendee.id &&
              <React.Fragment>
                <hr style={{borderStyle: 'dashed'}} />
                <Row form>
                  <Col md="12" className="form-group">
                    <div className="d-flex align-items-center">
                      <div className="flex-fill">
                        <div className="mb-0">อีเมล</div>
                      </div>
                      <Button 
                        type="link" 
                        className="p-0"
                        onClick={() => this.setState({drawerPreviewVisible: true})}
                      >ดูตัวอย่าง</Button>
                    </div>
                    <div className="mail-editor mt-2">
                      <ReactQuill 
                        theme="snow" 
                        value={this.state.attendee.emailBody} 
                        modules={{
                          toolbar: [
                            ['bold', 'italic', 'underline'],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'align': null}, {'align': 'center'}, {'align': 'right'}],
                            ['link']
                          ]
                        }}
                        onChange={(value) => this.handleAttendeeChange(value, 'emailBody')}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <div>
                      <label className="flex-fill mb-0">เอกสารเชิญประชุม</label>
                      <p className="font-12 mt-1 mb-3 text-muted"><span className="text-danger">*</span>เอกสารจะไม่ได้ถูกแนบไว้ในอีเมล กรุณาคัดลอกลิงก์ของเอกสารใส่ในเนื้อหาอีเมลเพื่อส่งให้ผู้เข้าประชุม</p>
                    </div>
                    
                    <Spin 
                      spinning={this.state.deleting}
                      indicator={<LoadingOutlined style={{ fontSize: 24, color: '#2a80b9' }} spin />}
                    >
                      { 
                        this.state.attendee.attachments.map((item, index) => {
                          return (
                            <div 
                              className="border py-2 px-3 mt-2 d-flex align-items-center rounded"
                              key={item.id}
                            >
                              { this.renderDocumentIcon(item.name) }
                              <div className="ml-2 flex-fill">
                                <a href={item.webUrl} target="_blank" style={{marginTop:-2}}>{ item.name }</a>
                                <div className="font-12 text-muted">
                                  { <Moment format="DD/MM/YYYY HH:mm:ss" add={{ years: 543 }}>{item.createdAt}</Moment>}
                                </div>
                              </div>

                              <CopyToClipboard 
                                text={item.webUrl}
                                options={{format: 'text/plain'}}
                                onCopy={() => message.success('คัดลอกลิงก์เรียบร้อยแล้ว') }>
                                <Tooltip title="คัดลอกลิงก์เอกสาร">
                                  <CopyOutlined 
                                    className="ml-3 pointer" 
                                    style={{fontSize: 20}}
                                  />
                                </Tooltip>
                              </CopyToClipboard>
                              <DeleteOutlined 
                                className="ml-3 pointer" 
                                style={{fontSize: 20}}
                                onClick={() => {
                                  const _this = this 

                                  Modal.confirm({
                                    title: <div>ยืนยันการลบเอกสาร <span className="font-weight-bold">{item.name}</span></div>,
                                    content: 'เมื่อลบเอกสารแล้วจะไม่สามารถนำกลับมาได้',
                                    okText: 'ลบ',
                                    cancelText: 'ยกเลิก',
                                    maskClosable: true,
                                    onOk() {  
                                      _this.deleteDocument(item, index)
                                    }
                                  });
                                }}
                              />
                            </div>
                          )
                        })
                      }

                      <Spin 
                        spinning={this.state.uploading}
                        indicator={<LoadingOutlined style={{ fontSize: 24, color: '#2a80b9' }} spin />}
                      >
                        <div className="border py-2 px-3 mt-2 d-flex align-items-center rounded">
                          <img
                            className="mr-2"
                            width="25"
                            src={require("assets/img/document.svg")}
                            alt="Document Icon"
                          />
                          <div className="ml-2 d-flex align-items-center flex-fill">
                            <div className="flex-fill">อัพโหลดเอกสารแนบ</div>
                            <Upload {...this.singleAttachmentProps}>
                              <Button>เลือกเอกสาร</Button>
                            </Upload>
                          </div>
                        </div>
                      </Spin>
                    </Spin>
                  </Col>
                </Row>

                <Drawer
                  title="ตัวอย่างอีเมล"
                  width={400}
                  closable={false}
                  onClose={() => this.setState({drawerPreviewVisible: false})}
                  visible={this.state.drawerPreviewVisible}
                >
                  <div className="email-preview">
                    <React.Fragment>
                      <p className="mb-3">เรียน <span className="ml-1">{this.state.attendee.name}</span></p>
                      <p dangerouslySetInnerHTML={{ __html: this.state.attendee.emailBody.replace(/\t/g, '\u00a0\u00a0\u00a0\u00a0'), }} /> 
                    </React.Fragment> 
                  </div>
                </Drawer>
              </React.Fragment>
            }
          </Spin>
        </Modal>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ 
  appReducer, 
  meetingReducer, 
  buildingsReducer,
  locationsReducer,
  roomsReducer,
  positionsReducer,
  departmentReducer
}) => ({
  appReducer,
  meetingReducer,
  buildingsReducer,
  locationsReducer,
  roomsReducer,
  positionsReducer,
  departmentReducer
});

const mapDispatchToProps = {
  ...meetingActions,
  ...positionActions,
  ...departmentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(MeetingEvent);
